import React from "react";

const Introduction = () => {
  return (
    <div className="content">
      <div className="content-wrapper">
        <p>
          At South East Water, we’re helping create a better world for our
          customers with forward thinking water solutions, for all and always
          that won’t cost the earth.
        </p>
        <p>
          We support healthy and liveable communities by delivering water,
          sewerage and recycled water services to those who rely on us every day
          and every night.
        </p>
        <p>
          Servicing 1.91 million people across Melbourne's south east, we manage
          more than 26,500 kilometres of pipeline and we own, operate and
          maintain $4.8 billion of assets including water, recycled water and
          sewerage networks.
        </p>
        <p>
          Our service region is also one of Australia’s most culturally diverse
          areas!
        </p>
        <p>
          Further information regarding projects and upgrades can be seen at our Digital Engagement Space, please visit&nbsp;
          <a
            target="_blank"
            href="https://consultationspace.com/SEW/"
            rel="noreferrer"
          >here</a>.
        </p>
      </div>
    </div>
  );
};

export default Introduction;
